export const INBOX_NAME = 'inbox_name'
export const INBOX_NAME_SPAM = 'spam'
export const INBOX_NAME_INBOX = 'inbox'

export const IS_READ = 1
export const IS_UNREAD = 0
export const IS_SPAM = 1
export const IS_NOT_SPAM = 0

export const ORIGINS = {
  ALL_ORIGINS: 'all_origins',
  LANDING: 'landing',
  POPUP: 'popup'
} as const
